import { render } from "./PanelAdminBulletinChange.vue?vue&type=template&id=dacc7b84&ts=true"
import script from "./PanelAdminBulletinChange.vue?vue&type=script&lang=ts"
export * from "./PanelAdminBulletinChange.vue?vue&type=script&lang=ts"

import "./PanelAdminBulletinChange.vue?vue&type=style&index=0&id=dacc7b84&lang=scss"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__